import { render, staticRenderFns } from "./TitikKumpulBencana.vue?vue&type=template&id=b8267c10&scoped=true"
import script from "./TitikKumpulBencana.vue?vue&type=script&lang=js"
export * from "./TitikKumpulBencana.vue?vue&type=script&lang=js"
import style0 from "./TitikKumpulBencana.vue?vue&type=style&index=0&id=b8267c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8267c10",
  null
  
)

export default component.exports